export function getOverrides(props, keys) {
  if (props === void 0) {
    props = {};
  }
  if (keys === void 0) {
    keys = [];
  }
  return keys.reduce((result, key) => {
    result[key] = props[key] || {};
    return result;
  }, {});
}